import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDiscoveredAssets, fetchAssetChanges, fetchDiscoveryJobs, startDiscoveryScan } from '../../services/api/networkDiscoveryService';

export const loadNetworkDiscovery = createAsyncThunk('networkDiscovery/load', async () => {
  const [assets, changes, jobs] = await Promise.all([
    fetchDiscoveredAssets(), fetchAssetChanges(), fetchDiscoveryJobs()
  ]);
  return { assets, changes, jobs };
});

export const launchScan = createAsyncThunk('networkDiscovery/launchScan', async (targetRange) => startDiscoveryScan(targetRange));

const networkDiscoverySlice = createSlice({
  name: 'networkDiscovery',
  initialState: { status: 'idle', error: null, scanStatus: 'idle', scanError: null, assets: [], changes: [], jobs: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadNetworkDiscovery.pending, (state) => { state.status = 'loading'; })
      .addCase(loadNetworkDiscovery.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.assets = action.payload.assets;
        state.changes = action.payload.changes;
        state.jobs = action.payload.jobs;
      })
      .addCase(loadNetworkDiscovery.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(launchScan.pending, (state) => { state.scanStatus = 'loading'; state.scanError = null; })
      .addCase(launchScan.fulfilled, (state, action) => {
        state.scanStatus = 'succeeded';
        state.jobs.unshift(action.payload);
      })
      .addCase(launchScan.rejected, (state, action) => {
        state.scanStatus = 'failed';
        state.scanError = action.error.message || 'Unable to launch network discovery scan.';
      });
  }
});

export default networkDiscoverySlice.reducer;
